export const hideSiteChrome = () => {
  const header = document?.getElementById("chrome-header");
  const footer = document?.getElementById("chrome-footer");
  const breadcrumb = document?.getElementById("chrome-breadcrumb");

  if (header) {
    header.style.display = "none";
  }

  if (footer) {
    footer.style.display = "none";
  }

  if (breadcrumb) {
    breadcrumb.style.display = "none";
  }
};
